import React, { useEffect, useState } from 'react';

import { Autocomplete as MuiAutocomplete, AutocompleteProps } from '@material-ui/lab';

const Autocomplete: <
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined
>(
  props: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo> & { needSearch?: boolean },
) => JSX.Element = (props): JSX.Element => {
  const { className, needSearch = true, ...rest } = props;

  const proxifiedValue = (value?: string) => {
    return String(value || '').trimStart();
  };

  const [value, setValue] = useState(proxifiedValue(rest.inputValue));

  useEffect(() => {
    setValue(proxifiedValue(rest.inputValue));
  }, [rest.inputValue]);

  return (
    <MuiAutocomplete
      {...rest}
      inputValue={proxifiedValue(value)}
      onInput={v => {
        if (needSearch) {
          setValue((v.target as HTMLInputElement).value);
          if (rest?.onInput) rest.onInput(v);
        }
      }}
      onChange={(e, v, r) => {
        setValue(proxifiedValue(rest.inputValue));
        if (rest?.onChange) rest.onChange(e, v, r);
        e.target.dispatchEvent(new Event('blur'));
      }}
      onBlur={e => {
        setValue(proxifiedValue(rest.inputValue));
        if (rest?.onBlur) rest.onBlur(e);
      }}
    />
  );
};

export default Autocomplete;
